import React from "react";

import { Box } from "@material-ui/core";
import { formatDistanceStrict } from "date-fns";
import { get } from "lodash";
import { makeStyles } from "@material-ui/styles";
import clsx from "clsx";

import { Height as HeightIcon } from "@material-ui/icons";

import { NextLessonOnFutureDayProps } from "./types";

const useStyles = makeStyles(() => ({
  container: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    flex: 1,
    boxShadow: "inset 0px -1px 0px #EEEEEE",
    padding: "1rem",
    minHeight: "72px",
  },
}));

const NextLessonOnFutureDay = ({ nextLesson }: NextLessonOnFutureDayProps) => {
  const classes = useStyles();

  return (
    <Box
      flexGrow={1}
      className={clsx(get(classes, "container"), "break")}
      data-test="calendar-summary-future-lesson-day"
    >
      <HeightIcon />
      {formatDistanceStrict(
        new Date(get(nextLesson, "startDateTime") || Date.now()),
        new Date(Date.now()),
      )}{" "}
      till next lesson
    </Box>
  );
};

export default NextLessonOnFutureDay;
